import { render, staticRenderFns } from "./OrdersAtTpc.vue?vue&type=template&id=0d1ac4dd"
import script from "./OrdersAtTpc.vue?vue&type=script&lang=ts"
export * from "./OrdersAtTpc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports